/** @format */

import { AssetNote, TRoom } from '@/ducks/room/declarations';
import React, {
  Dispatch,
  FunctionComponent as FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type CardRoomContextType = {
  room?: TRoom;
  url: string;
  title: string;
  isPopup: boolean;
  setRoom: Dispatch<SetStateAction<TRoom>>;
  setUrl: Dispatch<SetStateAction<string>>;
  setTitle: Dispatch<SetStateAction<string>>;
  assetNotes: AssetNote[];
  buildingType: string;
};

const emptyState: CardRoomContextType = {
  room: undefined,
  url: '',
  title: '',
  isPopup: false,
  setRoom: () => {},
  setUrl: () => {},
  setTitle: () => {},
};

export const CardRoomContext = createContext<CardRoomContextType>(emptyState);

export const CardRoomProvider: FC<CardRoomProviderProps> = ({
  children,
  initialRoom,
  initialUrl,
  initialTitle,
  isPopup,
}) => {
  const [room, setRoom] = useState<TRoom>(initialRoom);
  const [url, setUrl] = useState<string>(initialUrl);
  const [title, setTitle] = useState<string>(initialTitle);
  const [assetNotes, setAssetNotes] = useState<AssetNote[]>([...initialRoom.assetNotes]);
  const [buildingType, setBuildingType] = useState<string>(initialRoom.building.buildingType);

  return (
    <CardRoomContext.Provider
      value={{ room, setRoom, url, setUrl, title, setTitle, isPopup: isPopup ?? false, assetNotes, buildingType }}
    >
      {children}
    </CardRoomContext.Provider>
  );
};

export const useCardRoomContext = () => useContext(CardRoomContext);

interface CardRoomProviderProps {
  children: ReactNode;
  initialRoom: TRoom;
  initialUrl: string;
  initialTitle: string;
  isPopup?: boolean;
}
